<template>
    <div class="expenditures-container">
        <div class="expenditures-heading text-center collapsed" :class="expenditures.length ? 'clickable' : ''" data-toggle="collapse" data-target="#expenditures-body">
            <h5 v-if="hasExpenditures()" class="mb-0 text-black-50"><i class="fa"></i> {{transEdit('expenditures-for-month')}} ({{expenditures.length}} st, {{transEdit('sum').toLowerCase()}}: {{
                numberFormat(expendituresSum)}} kr)
            </h5>
            <h5 class="mb-0 text-black-50" v-else>{{transEdit('no-extra-expenditures-month')}}</h5>
        </div>
        <div class="expenditures-body collapse" id="expenditures-body">
            <div v-for="expenditure in expenditures" class="d-flex flex-fill justify-content-between border-top pt-2 pb-2 flex-column flex-md-row">
                <div class="">{{expenditure.expenditure_date}}</div>
                <div class="font-weight-bold flex-grow-1 pl-md-4">{{expenditure.description}}</div>
                <div class="text-md-right pr-md-4">{{numberFormat(expenditure.price)}} kr</div>

                <div>
                    <button class="btn btn-outline-primary btn-sm" @click="showDeleteExpenditureModal(expenditure)"><i class="fa fa-search"></i> {{transEdit('show')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "therapist-dash-expenditures-list",
        props: ['date', 'route_expenditures', 'do_refresh', 'locked'],
        data: function () {
            return {
                expenditures: [],
                expendituresSum: 0,
            }
        },
        watch: {
            date: function (newDate, oldDate) {
                this.fetchNewExpenditures(newDate);
            },
        },
        methods: {
            refresh() {
                this.fetchNewExpenditures(this.date);
            },
            canDeleteExpenditure: function (date) {
                let tempDate = new Date();
                tempDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), 1);
                let inputDate = new Date(date);

                return true;
            },
            showDeleteExpenditureModal: function (expenditure) {
                let info = {};
                info.showButton = !this.locked;
                info.date = expenditure.expenditure_date;
                info.registeredDate = moment(expenditure.created_at).format('YYYY-MM-DD HH:mm');
                info.price = this.numberFormat(expenditure.price);
                info.vat = expenditure.vat + "%";
                info.description = expenditure.description;
                info.reason = expenditure.reason;
                info.id = expenditure.id;

                this.$eventHub.$emit('therapist-delete-expenditure', info)
            },
            numberFormat: function (number) {
                return window.number_format(number);
            },
            hasExpenditures: function () {
                return this.expenditures.length > 0;
            },
            fetchNewExpenditures: function (date) {
                date = date.getYMD();
                let self = this;

                axios.get(this.$portalUrl(self.route_expenditures), {
                    params: {
                        date: date,
                    }
                })
                .then(function (response) {
                    let tempSum = 0;
                    response.data.forEach(function (expenditure) {
                        tempSum += expenditure.price;
                    });

                    self.expendituresSum = tempSum;
                    self.expenditures = response.data;
                })
                .catch(function (error) {
                });
            },
        }, mounted () {
            this.refresh();
        }
    }
</script>

<style scoped>

</style>
